/* 🤖 this file was generated by svg-to-ts */
export const mgcIconColumns2CuteFi: {
  name: 'columns-2-cute-fi';
  data: string;
} = {
  name: 'columns-2-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.24 2.548c-.143.006-.533.039-.866.072-1.596.158-2.554.532-3.363 1.313-.813.783-1.204 1.745-1.401 3.439-.062.542-.07 1.047-.07 4.628 0 4.319.011 4.605.22 5.621q.543 2.6385 2.877 3.42c.897.301 1.764.398 3.813.427l1.55.023V2.52l-1.25.008a69 69 0 0 0-1.51.02M13 12v9.491l1.55-.023c2.049-.029 2.916-.126 3.813-.427a4.06 4.06 0 0 0 1.626-.974c.806-.777 1.208-1.76 1.4-3.427.064-.555.071-1.04.071-4.64 0-4.319-.011-4.605-.22-5.621q-.543-2.6385-2.877-3.42c-.897-.301-1.764-.398-3.813-.427L13 2.509z"/></svg>`
};
